import React from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Checkbox,
  IconButton,
  MenuItem,
  Select,
  FormControl,
} from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
import MoreVertIcon from "@material-ui/icons/MoreVert";

const CandidatesTable = ({
  rows,
  pastDate,
  status,
  pdfData,
  handleCheckboxClick,
  handlePaymentStatus,
  signeePage,
  handleMenu,
  staffDetail,
  classes,
}) => {
  return (
    <Table className={classes?.table}>
      <TableHead>
        <TableRow>
          <TableCell style={{ width: 70 }} />
          <TableCell>Id</TableCell>
          <TableCell align="left">Name</TableCell>
          <TableCell align="left">Contact Number</TableCell>
          <TableCell align="left">Email</TableCell>
          <TableCell align="left">Booking Status</TableCell>
          {status === "CONFIRMED" && pastDate && (
            <TableCell align="left">Payment Status</TableCell>
          )}
          <TableCell align="left">Detail</TableCell>
          {!pastDate && <TableCell align="right">Action</TableCell>}
        </TableRow>
      </TableHead>

      <TableBody>
        {rows?.length > 0 ? (
          rows.map((row, index) => (
            <TableRow key={row.signeeId || index}>
              <TableCell>
                <Checkbox
                  value={row.signeeId}
                  checked={pdfData.signee_id.includes(row.signeeId)}
                  onClick={(e) => handleCheckboxClick(e, row.signeeId)}
                  className="selectCheckbox"
                />
              </TableCell>

              <TableCell>{index + 1}</TableCell>
              <TableCell>{row.first_name} {row.last_name}</TableCell>
              <TableCell>{row.contact_number}</TableCell>
              <TableCell>{row.email}</TableCell>
              <TableCell>{row.signee_booking_status}</TableCell>

              {status === "CONFIRMED" && pastDate && (
                <TableCell>
                  <FormControl variant="standard" fullWidth>
                    <Select
                      value={row.payment_status || ""}
                      name="payment_status"
                      onChange={(e) => handlePaymentStatus(e, row.signeeId)}
                      disabled={["Compliance", "Booking"].includes(staffDetail)}
                    >
                      <MenuItem value="PAID">Paid</MenuItem>
                      <MenuItem value="UNPAID">Unpaid</MenuItem>
                      <MenuItem value="ONHOLD">On Hold</MenuItem>
                    </Select>
                  </FormControl>
                </TableCell>
              )}

              <TableCell align="right">
                <span onClick={(e) => signeePage(e, row.signeeId)} className={classes?.viewBtn}>
                  <VisibilityIcon className="mr-2" />
                  View
                </span>
              </TableCell>

              {!pastDate && (
                <TableCell align="right">
                  {["REJECTED", "CANCEL"].includes(row.signee_booking_status) ? (
                    <IconButton disabled />
                  ) : (
                    <IconButton onClick={(e) => handleMenu(e, row.signeeId, row)}>
                      <MoreVertIcon />
                    </IconButton>
                  )}
                </TableCell>
              )}
            </TableRow>
          ))
        ) : (
          <TableRow>
            <TableCell colSpan={9} align="center">
              No records found
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
};

export default CandidatesTable;
